module.exports = __webpack_public_path__ + "static/assets/818cc10dfee980fa11921930747a6cf9.png";